export enum NCardsScreenWidth {
  fiveCardWidth = 1852,
  fourCardWidth = 1519,
  threeCardWidth = 1168,
  twoCardWidth = 826,
}
